import { FC } from 'react';

interface HighlightedTextProps {
  text: string;
  highlight?: string | null;
  highlightClassName?: string;
}

export const HighlightedText: FC<HighlightedTextProps> = ({
  text,
  highlight,
  highlightClassName = 'bg-yellow-200 text-gray-900 font-semibold rounded px-0.5',
}) => {
  if (!highlight) {
    return <>{text}</>;
  }

  const index = text.indexOf(highlight);
  if (index === -1) {
    return <>{text}</>;
  }

  const before = text.slice(0, index);
  const match = text.slice(index, index + highlight.length);
  const after = text.slice(index + highlight.length);

  return (
    <>
      {before}
      <mark className={highlightClassName}>{match}</mark>
      {after}
    </>
  );
};
